export const paths= {
    NEGOTIATE: "/onboardingmiddleware/negotiate"
}